import { render, staticRenderFns } from "./App.vue?vue&type=template&id=c3483a82&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=c3483a82&prod&lang=sass"
import style1 from "./App.vue?vue&type=style&index=1&id=c3483a82&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3483a82",
  null
  
)

export default component.exports